export default __webpack_public_path__ + "static/media/footer_image_6.450aa6a1.jpg";